export default "__VITE_ASSET__DZ6I1cmn__"